/**
 * Static files: frontend/public/
 *
 * Product films (YouTube embeds on the homepage).
 */
import { publicUrl } from '../lib/publicUrl';
export const PRODUCT_YOUTUBE = {
  hero: {
    id: 'i6Sk279Nx-Q',
    title: 'Overview — ThermaCube in action',
  },
  deepDive: {
    id: 'zpQ0Ph0U__Y',
    title: 'Features walkthrough',
  },
  everyday: {
    id: 'uV08hM0q38Q',
    title: 'Everyday use',
  },
  shortDemo: {
    id: 'D-dgq1aIvWM',
    title: 'Quick demo',
  },
  shortFit: {
    id: '1p7ialq-he8',
    title: 'Fit & how to wear',
  },
};

/** Grid on homepage (excludes hero — shown separately). */
export const PRODUCT_YOUTUBE_GRID = [
  PRODUCT_YOUTUBE.deepDive,
  PRODUCT_YOUTUBE.everyday,
  PRODUCT_YOUTUBE.shortDemo,
  PRODUCT_YOUTUBE.shortFit,
];

/**
 * Home hero (`HeroCinematic`) — `video-hero.mp4` mirrors the **ThermaCube deep dive** film
 * (YouTube `zpQ0Ph0U__Y` — features walkthrough). Re-download if you change the YouTube master.
 * For **PulsePad**: add `public/videos/video-hero-pulsepad.mp4` and point `homeTeaser` there.
 */
export const SITE_VIDEOS = {
  homeTeaser: '/videos/video-hero.mp4',
  fullFeature: '/videos/video-full.mp4',
};

export const SITE_IMAGES = {
  /** Nav / footer mark (replace with your PNG when ready) */
  sprintFitMark: publicUrl('/sprintfit-mark.svg'),
  /** ThermaCube — marketing still (see /public/thermacube/) */
  productListing: publicUrl('/thermacube/hero-split.png'),
};
